<template>
    <div class="pheader-wrap">
        <header class="header">
            <ul v-show="isLoginRegList">
                <li @touchend="goLoginOrReg(0)">登录</li>
                <li @touchend="goLoginOrReg(1)">注册</li>
            </ul>
            <h4 v-show="isWelcome"><span>欢迎你</span><span v-html="name?name:userName"></span></h4>
        </header>
        <div class="alertMark" v-show="isAlert">
            <div class="alert-content">
                <h4>{{myFromList.title}}<img src="../assets/03.png" @touchend="goHome" /></h4>
                <ul>
                    <li @touchend="goLoginOrReg(0)" :class="current==0?'active':''">
                        <p>登录</p>
                    </li>
                    <li @touchend="goLoginOrReg(1)" :class="current==1?'active':''">
                          <p>注册</p>
                    </li>
                </ul>
                <!-- 登录 -->
                <el-form :model="ruleLogin" :rules="rules" ref="ruleLogin" label-position="top" v-show="isLoginContent">
                    <el-form-item label="用户名" prop="userTel">
                        <el-input type="text" v-model.number="ruleLogin.userTel" auto-complete="off" :maxlength="11" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="userPwd">
                        <el-input type="password" v-model="ruleLogin.userPwd" placeholder="请输入密码"></el-input>
                    </el-form-item>
                    <span class="forgotPassword" @touchend="goLoginOrReg(2)">忘记密码</span>
                    <span class="myfrom-buttons" @touchend="getOperation('ruleLogin')">登 录</span>
                </el-form>
                <!-- 登录结束 -->
                <!-- 注册 -->
                <el-form label-position="top" :model="registered" :rules="registeredRules" ref="registered" v-show="isRegForm">
                    <el-form-item label="手机号" prop="userTel">
                        <el-input type="text" v-model.number="registered.userTel" auto-complete="off" :maxlength="11" placeholder="请输入手机号" @blur="regPhone"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="zcuserPwd">
                        <el-input type="password" v-model="registered.zcuserPwd" placeholder="请输入6-16位数字或字母"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="sendSecond" class="regCodeFrom">
                        <el-input type="text" v-model="registered.sendSecond" placeholder="请输入验证码" class="regCode" :maxlength="6"></el-input>
                        <el-button @click="getRegCode" :disabled="dis" class="codebutton">获取验证码<i v-show="isSecond"> {{secondText}}s</i></el-button>
                    </el-form-item>
                    <span class="myfrom-buttons" @touchend="getRegInfo('registered')">注 册</span>
                </el-form>
                <!-- 注册结束 -->
                <!-- 重置密码1 -->
                <el-form label-position="top" v-show="isForgotPassword" :model="setNewPassword" :rules="newPas" ref="setNewPassword">
                    <el-form-item label="用户名" prop="userTel">
                        <el-input type="text" :maxlength="11" v-model.number="setNewPassword.userTel" auto-complete="off" placeholder="手机号" @blur="setregPhone"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="sendSecond" class="regCodeFrom">
                        <el-input type="text" placeholder="请输入验证码" v-model="setNewPassword.sendSecond" class="regCode" :maxlength="6"></el-input>
                        <el-button @click="getRegNumber" :disabled="disab" class="codebutton">获取验证码<i v-show="isSecondT"> {{secondTextT}}s</i></el-button>
                    </el-form-item>
                    <span class="myfrom-buttons" @touchend="goResetPassword('setNewPassword')">下 一 步</span>
                </el-form>
                <!-- 重置密码1结束 -->
                <el-form label-position="top" v-show="isNewPassword" :model="ruleForm2" :rules="rules2" ref="ruleForm2">
                    <el-form-item label="请输入新密码" prop="pass">
                        <el-input type="password" placeholder="请输入6-16位数字或字母" v-model="ruleForm2.pass" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="请确认登录密码" prop="checkPass">
                        <el-input type="password" placeholder="请输入6-16位数字或字母" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
                    </el-form-item>
                    <span class="myfrom-buttons" @touchend="getNewPwd('ruleForm2')">确 定</span>
                </el-form>
            </div>
        </div>
        <footer class="footer">
			<ul>
				<li>
					<p @touchend="changeIndex(0)" :class="ind==0?'active':''">首页</p>
				</li>
				<li>
					<p @touchend="changeIndex(1)" :class="ind==1?'active':''">我的报告</p>
				</li>
				<li>
					<p @touchend="getMoreInfo">更多</p>
					<div class="dropdowns" v-show="isDropdowns">
						<ul>
							<li>
								<span @click="goSetInfo">个人设置</span>
							</li>
							<li>
								<span @click="goOrdErmanagement">订单管理</span>
							</li>
							<li>
								<span @touchend="setExit">退出系统</span>
								<img src="../assets/sanjiao.png" />
							</li>
						</ul>
					</div>
				</li>
			</ul>
		</footer>
    </div>
</template>
<script>
	import store from '../vuex/store';
		import {
			mapGetters
		} from 'vuex';
	const props = {
		name: {
			type: String,
			default: ''
		}
	}
    export default {
        props,
        data() {
            var reg = /^1[3|4|5|7|8][0-9]{9}$/;
            var checkAccount = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号不能为空'));
                }
                setTimeout(() => {
                    if (!Number.isInteger(value)) {
                        callback(new Error('请输入数字值'));
                    } else {
                        if (!reg.test(value)) {
                            callback(new Error('用户名名格式错误'));
                        } else {
                            callback();
                        }
                    }
                }, 1000);
            };
            var pwdReg = /^[0-9a-zA-Z_#]{6,16}$/;
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.ruleForm2.checkPass !== '') {
                        this.$refs.ruleForm2.validateField('checkPass');
                    } else if (!pwdReg.test(value)) {
                        callback(new Error('用户名名格式错误'));
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm2.pass) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                current: 0,
                isAlert: false,
                myIScroll: null,
				isDropdowns: false,
                myFromList: {
                    title: "",
                },
                isLoginContent: true,
                isRegForm: false,
                isForgotPassword: false,
                isLoginRegList: true,
                isSecond: false,
                isSecondT: false,
                isWelcome: false,
                secondText: 120,
                secondTextT: 120,
                userName: null,
                isNewPassword: false,
                dis: false,
                disab: false,
                ruleLogin: { // 登录效验
                    userTel: '',
                    userPwd: ''
                },
                registered: { // 注册效验
                    userTel: '',
                    zcuserPwd: '',
                    sendSecond: '',
                },
                setNewPassword: { //重置密码
                    userTel: '',
                    sendSecond: '',
                },
                ruleForm2: { //再次确定
                    pass: '',
                    checkPass: '',
                },
                rules: {
                    userTel: [{
                        required: true,
                        validator: checkAccount,
                        trigger: 'blur'
                    }],
                    userPwd: [{
                        required: true,
                        message: '密码不能为空',
                        trigger: 'blur'
                    }]
                },
                newPas: {
                    userTel: [{
                        required: true,
                        validator: checkAccount,
                        trigger: 'blur'
                    }],
                    sendSecond: [{
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur'
                    }]
                },
                rules2: {
                    pass: [{
                        required: true,
                        validator: validatePass,
                        trigger: 'blur'
                    }],
                    checkPass: [{
                        required: true,
                        validator: validatePass2,
                        trigger: 'blur'
                    }],
                },
                registeredRules: {
                    userTel: [{
                        required: true,
                        validator: checkAccount,
                        trigger: 'blur'
                    }],
                    zcuserPwd: [{
                        required: true,
                        message: '密码不能为空',
                        trigger: 'blur'
                    }],
                    sendSecond: [{
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur'
                    }]
                }
            }
        },
        methods: {
            goLoginOrReg(ind) {
                this.current = ind;
                this.isAlert = true;
                if (ind == 0) {
                    this.isLoginContent = true;
                    this.isRegForm = false;
                    this.isNewPassword = false;
                    this.isForgotPassword = false;
                    this.myFromList.title = "登录";
                } else if (ind == 1) {
                    this.isLoginContent = false;
                    this.isRegForm = true;
                    this.isNewPassword = false;
                    this.isForgotPassword = false;
                    this.myFromList.title = "手机号注册";
                } else if (ind == 2) {
                    this.isLoginContent = false;
                    this.isRegForm = false;
                    this.isNewPassword = false;
                    this.isForgotPassword = true;
                    this.myFromList.title = "重置密码";
                }
            },
            goHome() {
                this.isAlert = false;
                this.isSecond = false;
                this.dis = false;
                this.isSecond = false;
            },
            getOperation(formName) { // 点击登录
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        console.log(this.ruleLogin.userTel)
                        console.log(this.ruleLogin.userPwd)
                        this.$http.post(urls.urltest + "/personal/login.json", {
                            phone: this.ruleLogin.userTel,
                            password: this.ruleLogin.userPwd
                        }).then(function(res) {
                            if (res.body) {
                                this.isAlert = false;
                                this.isWelcome = true;
                                this.isLoginRegList = false;
                                localStorage.setItem("token", res.body.token);
                                localStorage.setItem("userName", res.body.object.username);
                                this.userName = localStorage.getItem("userName");
                                this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName
                            } else {
                                this.$message({
                                    message: '错了哦，请确认登录名或密码',
                                    type: 'error'
                                });
                            }
                        })
                    }
                })
            },
            getRegInfo(formName) { // 点击注册
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$http.post(urls.urltest + "/personal/registUser.json", {
                            phone: this.registered.userTel,
                            password: this.registered.zcuserPwd,
                            code: this.registered.sendSecond
                        }).then(function(res) {
                            this.isAlert = false;
                            this.isWelcome = true;
                            this.isLoginRegList = false;
                            localStorage.setItem("userName", res.body.object.username);
                            this.userName = localStorage.getItem("userName");
                            this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName
                            localStorage.setItem("token", res.body.token);
                        })
                    } else {
                        return false;
                    }
                })
            },
            goResetPassword(formName) { //点击下一步
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$http.post(urls.urltest + "/personal/checkPhoneCode.json", {
                            code: this.setNewPassword.sendSecond,
                            phone: this.setNewPassword.userTel
                        }).then(function(res) {
                            if (res.body) {
                                this.isLoginContent = false;
                                this.isRegForm = false;
                                this.isForgotPassword = false;
                                this.isNewPassword = true;
                            } else {
                                this.$message({
                                    message: '验证码输入不正确',
                                    type: 'error'
                                });
                                return false;
                            }
                        })
                    } else {
                        return false;
                    }
                })
            },
            getNewPwd(formName) { // 点击确定
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$http.post(urls.urltest + "/personal/changePassword.json", {
                            phone: this.setNewPassword.userTel,
                            password: this.ruleForm2.checkPass
                        }).then(function(res) {
                            this.isAlert = false;
                            this.isWelcome = true;
                            this.isLoginRegList = false;
                             localStorage.setItem("token", res.body.token);
                            this.$message({
                                message: '密码修改成功',
                                type: 'success'
                            });
                        })
                    } else {
                        return false;
                    }
                })
            },
            changeIndex(index) {
				console.log(index + "gxj")
				if (index == 0) {
					this.$store.dispatch("changeIndex", index)
					this.$router.replace('/')
				} else {
					if(localStorage.getItem("token")){
						this.$store.dispatch("changeIndex", index)
						this.$router.replace('/pmybaogao')
					}else{
						this.goLoginOrReg(0)
					}
				}
			},
            getMoreInfo(){  // 点击更多
				if(localStorage.getItem("token")){
					console.log(this.isDropdowns)
					this.isDropdowns = !this.isDropdowns;
					console.log(this.isDropdowns)
				}else{
					this.goLoginOrReg(0)
				}
			},
			goSetInfo() {
				this.$router.replace('/psetinfo');
                this.isDropdowns = false;	
                this.$store.dispatch("changeIndex", -1)			
			},
			goOrdErmanagement() {
				this.$router.replace('pordermanagement');
                this.isDropdowns = false;	
                this.$store.dispatch("changeIndex", -1)			
			},
			setExit(){
				this.$http.post(urls.urltest + '/personal/loginout.json', {
					token: localStorage.getItem('token')
				}).then(function(res) {
					localStorage.clear();
					this.isLoginRegList = true;
					this.isWelcome = false;
					this.isDropdowns = false;
                    this.$router.replace('/')
                    this.$store.dispatch("changeIndex", 0);
				})
			},
            regPhone() { // 注册判断用户名是否已注册
                this.$http.post(urls.urltest + '/personal/checkUserExist.json', {
                        phone: this.registered.userTel
                    })
                    .then(function(res) {
                        // console.log(res.body)
                        if (res.body == "1") {
                            this.$message({
                                message: '手机号码已经注册',
                                type: 'error'
                            });
                        }
                    })
            },
            setregPhone() {
                // 重置密码判断用户名
                this.$http.post(urls.urltest + "/personal/checkUserExist.json", {
                        phone: this.setNewPassword.userTel
                    })
                    .then(function(res) {
                        if (res.body == "0") {
                            this.$message({
                                message: '用户不存在',
                                type: 'error'
                            });
                            return false;
                        }
                    })
            },
            getRegCode() {
                console.log(0)
                if (this.registered.userTel == '') {
                    this.$message({
                        message: '请填写手机号码',
                        type: 'error'
                    });
                 } else if(!this.registered.userTel == ''){
                        this.$http.post(urls.urltest + '/personal/checkUserExist.json', {
                                phone: this.registered.userTel
                        }).then(function(res) {
                            if (res.body == "1") {
                                this.$message({
                                    message: '手机号码已经注册',
                                    type: 'error'
                                });
                            } else {
                                var _this = this;
                                this.isSecond = true;
                                this.dis = false;
                                this.$http.post(urls.urltest + "/personal/getRegistCheckCode.json", {
                                        phone: this.registered.userTel,
                                }).then(function(res) {
                                    console.log(res.body)
                                    var timer = null;
                                    var sT = this.secondText * 1;
                                    timer = setInterval(function() {
                                        if (sT > 0) {
                                            _this.dis = true;
                                            sT--;
                                        }
                                        _this.secondText = sT;
                                        if (_this.secondText <= 0) {
                                            _this.dis = false
                                            clearInterval(timer)
                                            _this.isSecond = false;
                                            _this.secondText = 120
                                        } 
                                    }, 1000);
                                })
                            }
                    })
                }
            },
        getRegNumber() {
            if (this.setNewPassword.userTel == '') {
                this.$message({
                                message: '请填写手机号码',
                                type: 'error'
                            });
            } else if(!this.setNewPassword.userTel == ''){
                this.$http.post(urls.urltest + '/personal/checkUserExist.json', {
                        phone: this.setNewPassword.userTel
                }).then(function(res) {
                        if (res.body == "0") {
                            this.$message({
                                message: '用户不存在',
                                type: 'error'
                            });
                        } else {
                            var _this = this;
                            this.isSecondT = true;
                            this.disab = false;
                            this.$http.post(urls.urltest + "/personal/getChangePassWordCode.json", {
                                phone: this.setNewPassword.userTel,
                            }).then(function(res) {
                                console.log(res.body)
                                var timer = null;
                                var sT = this.secondTextT * 1;
                                timer = setInterval(function() {
                                    if (sT > 0) {
                                        _this.disab = true;
                                        sT--;
                                    }
                                    _this.secondTextT = sT;
                                    if (_this.secondTextT <= 0) {
                                        clearInterval(timer)
                                        _this.disab = false;
                                        _this.isSecondT = false;
                                        _this.secondTextT = 120
                                    }
                                }, 1000);
                            })
                        }
                    })
                }	
            }
        },
        created(){
			if(localStorage.getItem("token")){
				this.isWelcome = true;
				this.isLoginRegList = false;
				this.userName = localStorage.getItem("userName");
			    this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName
			}
		},
		store,
		computed: {
			...mapGetters([
				'ind'
			])
		},
    }
</script>
<style lang="scss">
    
</style>





// WEBPACK FOOTER //
// pheader.vue?32ddd380